import { render, staticRenderFns } from "./WorkCalendarAmtliJourneyHeader.vue?vue&type=template&id=28cd5668&scoped=true"
import script from "./WorkCalendarAmtliJourneyHeader.vue?vue&type=script&lang=js"
export * from "./WorkCalendarAmtliJourneyHeader.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarAmtliJourneyHeader.vue?vue&type=style&index=0&id=28cd5668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd5668",
  null
  
)

export default component.exports